import { SimpleGrid } from "@chakra-ui/react";
import React from "react";
import { Field, Form } from "react-final-form";
import InputField from "../../../fields/InputField";

type CreateUserFormProps = {
  onSubmit: (...params: any) => void;
};

const RegisterForm = (props: CreateUserFormProps) => {
  const { onSubmit } = props;

  return (
    <Form onSubmit={onSubmit}>
      {(props) => {
        return (
          <form onSubmit={props.handleSubmit} id={"registerAccount"}>
            <SimpleGrid columns={[1]} spacing={5} p="10">
              <Field name="name" label="Name" component={InputField} />

              <Field
                name="phone"
                label="Phone"
                type="tel"
                component={InputField}
              />
              <Field
                name="email"
                label="Email"
                type="email"
                component={InputField}
              />
            </SimpleGrid>
          </form>
        );
      }}
    </Form>
  );
};

export default RegisterForm;
